import { setTheme } from "../utils/setTheme";

export class BodyMutationObserver {
    private observer: MutationObserver;

    constructor() {
        this.observer = new MutationObserver(this.handleMutation);
        this.observeBody();
    }

    private observeBody() {
        const targetNode = document.body;
        const config: MutationObserverInit = { attributes: true, attributeFilter: ["class", "dir"] };
        this.observer.observe(targetNode, config);
    }

    private handleMutation(mutationsList: MutationRecord[]) {
        for (const mutation of mutationsList) {
            if (mutation.type === "attributes") {
                // be sure, we switch only at theme change
                if (document.body.classList.contains("ux-theme-web")) {
                    setTheme("web");
                } else if (document.body.classList.contains("ux-theme-responsive")) {
                    setTheme("responsive");
                }
            }
        }
    }

    disconnect() {
        this.observer.disconnect();
    }
}
